import {useMemo, useState, useEffect} from 'react'
import styled from 'styled-components'
import useRouter from 'hooks/useRouter'
import useUserLoginStatus from 'hooks/useUserLoginStatus'
import useUserInfoProvider from 'hooks/useUserInfoProvider'
import useAdlProvider from 'hooks/useAdlProvider'
import useUserInfo from 'hooks/useUserInfo'
import useSymbolInfo from 'hooks/useSymbolInfo'
import useDialogStatus from 'hooks/useDialogStatus'
import useLeverageData from 'hooks/useLeverageData'
import {
  LOGIN_PRURL,
  REGISTER_URL,
  USER_CENTER_URL,
  HELP_URL,
  FUTURES_URL,
  DECIMAL_PLACE,
  isTestnet,
  SETTING,
  DIALOGS
} from 'constants'
import {cookie} from '@binance/js-sdk'
import {useDispatch} from 'redux-react-hook'
import {
  Logo, Card, Flex, Priceline
} from '@binance/uikit'
import useTicker from 'hooks/useTicker'
import {auth as authAction} from 'actions'
import tipMsgData from 'assets/tipMsgData'
import locales from 'assets/locales'
import HeaderMenu from './HeaderMenu'

const {leverageInfo} = SETTING

const StyledLogo = styled.div`
  img {
    width: 140px;
    height: 60px;
    margin-top: -14px;
  }
`

export default function Header ({i18n}) {
  const dispatch = useDispatch()
  const [loginUrl, setLoginUrl] = useState('')
  const router = useRouter()
  const {symbol, lng = 'en'} = router.query
  const ticker = useTicker(symbol)
  const {symbolInfo} = useSymbolInfo()
  const {baseAsset} = symbolInfo
  const isLogin = useUserLoginStatus()
  const [urls, setUrls] = useState({})

  useUserInfoProvider()
  useAdlProvider()

  const {userInfo, userLogout} = useUserInfo()
  const {switchDialog} = useDialogStatus()
  const {leverageData} = useLeverageData()
  const {curLeverage} = leverageData

  useEffect(() => {
    setLoginUrl(`${LOGIN_PRURL}?callback=${window.location.href}`.replace('$locale', lng))
    setUrls({
      login: loginUrl,
      register: REGISTER_URL.replace('$locale', lng),
      help: HELP_URL[lng] || HELP_URL.en,
      ...(!isTestnet && {usercenter: USER_CENTER_URL.replace('$locale', lng)})
    })
  }, [dispatch, lng, loginUrl])

  const logoProps = useMemo(
    () => ({
      ...(!isTestnet && {href: `/${lng}`}),
      customIcon: <img src={require('assets/logo.svg')} />
    }),
    [lng]
  )

  return useMemo(
    () => (
      <Card
        gridArea="header"
        flexDirection="column"
        justifyContent="space-between"
        alignItems="center"
        m={[12, 16]}
        className="header-mobile"
      >
        <Flex alignItems="center" justifyContent="inherit">
          <StyledLogo>
            <Logo {...logoProps} />
          </StyledLogo>
          <HeaderMenu
            username={userInfo?.email || ''}
            isLogin={isLogin}
            urls={urls}
            i18n={i18n}
            lang={lng}
            locales={locales}
            path={FUTURES_URL}
            handleLogout={() => {
              userLogout().then(() => {
                cookie.deleteCookie('logined')
                cookie.deleteCookie('p20t')
                cookie.deleteCookie('cr00')
                cookie.deleteCookie('cid')
                dispatch(authAction(false))
              })
            }}
          />
        </Flex>
        <Flex justifyContent="space-between" flex="1">
          <Priceline
            {...ticker}
            i18n={i18n}
            asset={baseAsset}
            decimalPlace={DECIMAL_PLACE}
            tipMsgData={tipMsgData}
            leverage={curLeverage}
            leverageSymbol={leverageInfo.symbol}
            onLeverageClick={() => switchDialog(DIALOGS.LEVERAGE_DIALOG)}
            mobile
          />
        </Flex>
      </Card>
    ),
    [logoProps, userInfo, isLogin, urls, i18n, lng, ticker, baseAsset, curLeverage, userLogout, dispatch, switchDialog]
  )
}
